module.exports = __webpack_public_path__ + "img/Japan2.7860e63c.png";